import React from 'react';
import { Controller, Control, UseFormTrigger } from 'react-hook-form';
import { TFunction } from 'i18next';
import { formRequiredRules } from 'helper';
import { errorMessage } from 'constants/CommonConstants';

interface Color {
  name: string;
  swatch_list: string[];
}

interface ColorListStyles {
  containerClass?: string;
  listClass?: string;
  itemClass?: string;
  labelClass?: string;
  paletteClass?: string;
  nameClass?: string;
}

interface ColorListProps {
  colorList: Color[];
  control: Control<any>;
  trigger: UseFormTrigger<any>;
  name: string;
  t: TFunction<string>;
  styles: ColorListStyles;
  listClass?: string;
  itemClass?: string;
  labelClass?: string;
  paletteClass?: string;
  nameClass?: string;
}

const ColorList: React.FC<ColorListProps> = ({ colorList, control, trigger, name, t, styles = {} }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={formRequiredRules(errorMessage(t).radioError)}
      render={({ field, field: { onChange }, formState: { errors } }) => (
        <>
          <ul className={`list-unstyled ${styles.listClass}`}>
            {colorList.map((color, index) => (
              <li
                key={`${color.name}_${index}`}
                className={styles.itemClass}
                onChange={(val) => {
                  onChange((val.target as HTMLInputElement)?.value);
                  trigger(name);
                }}
              >
                <label className={styles.labelClass}>
                  <input
                    type='radio'
                    {...field}
                    value={color.name}
                    checked={field.value === color.name}
                    style={{ display: 'none' }}
                  />
                  <span
                    className={styles.paletteClass}
                    style={{
                      backgroundColor: color.swatch_list[0],
                    }}
                  ></span>
                  <span className={styles.nameClass}>{color.name}</span>
                </label>
              </li>
            ))}
          </ul>
          {errors?.[name] ? <span className='validation-error'>{errors[name]?.message}</span> : null}
        </>
      )}
    />
  );
};

export default ColorList;
